import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromClaims from '../actions/claims.actions';
import { ClaimsService } from './claims.service';

@Injectable()
export class ClaimsEffects {

     loadClaims$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromClaims.LOAD),
        switchMap(() =>
            this.claimsService.getClaims().pipe(
                map((resultaat) => resultaat.data.dossier),
                map((payload: fromClaims.LoadSuccess) => new fromClaims.LoadSuccess(payload)),
                catchError((error) => of(new fromClaims.LoadError(error))),
            ),
        ),
    ));

     loadDetail$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromClaims.LOAD_DETAIL),
        switchMap((action: fromClaims.LoadDetail) =>
            this.claimsService.getClaimDetail(action.payload.dossier_volgnummer).pipe(
                map((resultaat) => resultaat.data),
                map((payload: fromClaims.LoadDetailSuccess) => new fromClaims.LoadDetailSuccess(payload)),
                catchError((error) => of(new fromClaims.LoadError(error))),
            ),
        ),
    ));

     loadProcessSteps$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromClaims.LOAD_PROCESS_STEPS),
        switchMap((action: fromClaims.LoadProcessSteps) =>
            this.claimsService.getProcessSteps(action.payload.dossier_volgnummer).pipe(
                map((resultaat) => resultaat.data),
                map((payload: fromClaims.LoadProcessStepsSuccess) => new fromClaims.LoadProcessStepsSuccess({
                    processSteps: payload,
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                })),
                catchError((error) => of(new fromClaims.LoadError(error))),
            ),
        ),
    ));

     loadActions$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromClaims.LOAD_ACTIONS),
        switchMap((action: fromClaims.LoadActions) =>
            this.claimsService.getClaimActions(action.payload.dossier_volgnummer).pipe(
                map((resultaat) => resultaat.data),
                map((payload: fromClaims.LoadActionsSuccess) => new fromClaims.LoadActionsSuccess({
                    actions: payload,
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                })),
                catchError((error) => of(new fromClaims.LoadError(error))),
            ),
        ),
    ));

     cancel$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromClaims.CANCEL),
        switchMap((action: fromClaims.Cancel) =>
            this.claimsService.cancelClaim(action.payload.dossier_volgnummer).pipe(
                map( () => new fromClaims.CancelSuccess(action.payload)),
                catchError((error) => of(new fromClaims.LoadError(error))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions,
        private claimsService: ClaimsService,
    ) {}
}
